export default "__VITE_ASSET__7cf81330__"